import React from 'react'
import { bool, func, node, string } from 'prop-types'
import IcoArrow from '../icons/IcoArrow'
import IcoCheck from '../icons/IcoCheck'
import { Root, IconWrap, Body, Title, Meta, MetaDica, ArrowWrap } from './styles'

export default function PAction( { icon, title, meta, dica, danger, primary, done, onClick } ) {
  const isInteractive = Boolean( onClick ) && !done
  return (
    <Root
      $danger={ danger }
      $done={ done }
      $interactive={ isInteractive }
      $primary={ primary }
      aria-disabled={ !isInteractive }
      disabled={ !isInteractive }
      onClick={ isInteractive ? onClick : null }
      type="button"
    >
      <IconWrap
        $danger={ danger }
        $done={ done }
        $primary={ primary }
      >
        { icon }
      </IconWrap>
      <Body>
        <Title>{ title }</Title>
        { meta ? (
          <Meta>
            { meta }
            { dica ? <MetaDica> · { dica }</MetaDica> : null }
          </Meta>
        ) : null }
      </Body>
      <ArrowWrap $done={ done }>
        { done ? (
          <IcoCheck
            height="16"
            width="16"
          />
        ) : (
          <IcoArrow
            height="15"
            width="15"
          />
        ) }
      </ArrowWrap>
    </Root>
  )
}

PAction.propTypes = {
  'icon': node.isRequired,
  'title': string.isRequired,
  'meta': string,
  'dica': string,
  'danger': bool,
  'primary': bool,
  'done': bool,
  'onClick': func
}

PAction.defaultProps = {
  'meta': null,
  'dica': null,
  'danger': false,
  'primary': false,
  'done': false,
  'onClick': null
}
